import React from 'react';
import {
  startOfMonth,
  startOfWeek,
  addDays,
  isSameMonth,
  isSameDay,
  isWithinInterval,
  format,
} from 'date-fns';
import { es } from 'date-fns/locale';
import './index.css';

type CalendarDay = {
  date: Date;
  isCurrentMonth: boolean;
};

interface CalendarGridProps {
  visibleMonth: Date;
  from: Date;
  to: Date;
  onSelect: (date: Date) => void;
  disablePastFrom?: boolean
}

const CalendarGrid: React.FC<CalendarGridProps> = ({
  visibleMonth,
  from,
  to,
  onSelect,
  disablePastFrom = false
}) => {
  const start = startOfWeek(startOfMonth(visibleMonth), { weekStartsOn: 1 });

  const days: CalendarDay[] = Array.from({ length: 42 }, (_, i) => {
    const date = addDays(start, i);
    return {
      date,
      isCurrentMonth: isSameMonth(date, visibleMonth),
    };
  });

  const isInRange = (date: Date) => {
    return isWithinInterval(date, { start: from, end: to });
  };

  const weekdays = Array.from({ length: 7 }, (_, i) => {
    const day = addDays(new Date(2023, 0, 2), i);
    return format(day, 'EEEEE', { locale: es }).toUpperCase();
  });

  const renderDayCell = (day: CalendarDay, index: number) => {
    const { date, isCurrentMonth } = day;
    const selectedFrom = isSameDay(date, from);
    const selectedTo = isSameDay(date, to);
    const inRange = isInRange(date) && !selectedFrom && !selectedTo;
    const isToday = isSameDay(date, new Date());

    // const disabled = !isCurrentMonth && (disablePastFrom && date < from);
    const disabled = disablePastFrom && date < from;

    const classNames = [
      'calendar-day',
      disabled && 'inactive',
      selectedFrom || selectedTo ? 'selected' : '',
      inRange ? 'in-range' : '',
      isToday ? 'today' : '',
      !isCurrentMonth ? 'not-current-month' : ''
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <button
        key={index}
        className={classNames}
        onClick={() => onSelect(date)}
        disabled={disabled}
      >
        {format(date, 'd', { locale: es })}
      </button>
    );
  };


  return (
    <>
      <div className="calendar-weekdays">
        {weekdays.map((day, i) => (
          <div key={i} className="calendar-weekday">
            {day}
          </div>
        ))}
      </div>

      <div className="calendar-grid">
        {days.map(renderDayCell)}
      </div>
    </>
  );
};

export default CalendarGrid;
